import { useState, ReactNode } from 'react';
import { DarkModeContext } from './DarkModeContext';

type Props = {
  children: ReactNode;
  initialDarkMode?: boolean;
};

export const DarkModeContextProvider = ({
  initialDarkMode = false,
  children
}: Props): JSX.Element => {
  const [isDarkMode, setIsDarkMode] = useState(initialDarkMode);

  return (
    <DarkModeContext.Provider value={{ isDarkMode, setIsDarkMode }}>
      {children}
    </DarkModeContext.Provider>
  );
};
